<template>
  <div class="w-[95%] mx-auto my-[20px]">
    <div v-if="isLoading">Loading</div>
    <slot v-if="!isLoading && invoice">
      <invoice-content :data="invoice" />
      <div class="flex justify-end mt-4" v-if="false">
        <button
          @click="download"
          class="text-secondary-600 bg-primary-600 hover:bg-primary-500 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none inline-flex items-center disabled:bg-disabled-300 disabled:shadow-none disabled:ring-0 disabled:cursor-not-allowed disabled:bg-primary-500"
          :disabled="isDownloading"
          type="button"
        >
          <span v-if="isDownloading">
            <svg
              aria-hidden="true"
              role="status"
              class="inline w-4 h-4 mr-2 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB" />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor" />
            </svg>
          </span>
          <span>
            Download
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 ml-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
        </button>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { Get, Download } from '@/api/invoice';
import { notify } from 'notiwind';

import InvoiceContent from '@/components/order/InvoiceContent.vue';

const invoice = ref({});
const route = useRoute();

const isDownloading = ref(false);
const isLoading = ref(false);

const download = async () => {
  try {
    isDownloading.value = true;
    const { data } = await Download(`${import.meta.env.VITE_APP_INVOICE_URL}/${route.params?.id}/download`);

    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `invoice-${invoice.value.number.replace('#', '')}.pdf`); // or any other extension
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    let message;
    if (error.response) {
      message = error.response.data.message;
    }
    message = message ?? 'An error occured while downloading the invoice';
    notify(
      {
        variant: 'bg-red-700',
        group: 'foo',
        text: message,
      },
      5000,
    );
  } finally {
    isDownloading.value = false;
  }
};
onMounted(async () => {
  try {
    isLoading.value = true;

    const { data: { data } } = await Get(route.params?.id ?? 'id-is-null');
    invoice.value = data;
  } catch (error) {
    let message;
    if (error.response) {
      message = error.response.data.message;
    }
    message = message ?? 'An error occured while loading the invoice';
    notify(
      {
        variant: 'bg-red-700',
        group: 'foo',
        text: message,
      },
      5000,
    );
  } finally {
    isLoading.value = false;
  }
});
</script>
